import TextFieldValidation from '@components/TextFieldValidation/TextFieldValidation';
import { LoadingButton } from '@mui/lab';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography
} from '@mui/material';
import { stringNotAnyValidationScheme } from '@utils/validation';
import { useFormik } from 'formik';
import React from 'react';
import { IProjectData, ProjectContext } from 'routes/ProjectProvider';
import { IDialogProps } from 'types/common';
import { IProjectCreate } from 'types/settings';
import { object } from 'yup';

const FORM_KEYS = {
	name: 'name'
};

interface IProjectCreateDialogProps extends IDialogProps<IProjectCreate> {
	companyName: string;
}

const ProjectCreateDialog = ({
	onSubmit,
	onCancel,
	companyName
}: IProjectCreateDialogProps) => {
	const { projectsList } = React.useContext<IProjectData>(ProjectContext);

	const formik = useFormik<IProjectCreate>({
		initialValues: {
			name: ''
		},
		validationSchema: object({
			[FORM_KEYS.name]: stringNotAnyValidationScheme(
				true,
				projectsList,
				'projects.creation.dialog.input.name.unique'
			)
		}),
		onSubmit
	});

	return (
		<Dialog
			open
			maxWidth="sm"
			disableRestoreFocus
			data-testid="project-create-dialog"
		>
			<DialogTitle>{intl.tr('projects.creation.dialog.title')}</DialogTitle>
			<DialogContent>
				<Box pt={2} pb={2}>
					<Grid container spacing={2}>
						<Grid item container xs={12}>
							<Grid item xs={12} pb={2}>
								<TextFieldValidation
									id={FORM_KEYS.name}
									formik={formik}
									required
									fullWidth
									autoFocus
									label={intl.tr('projects.creation.dialog.input.name.label')}
								/>
							</Grid>
							<Grid>
								<Typography variant="body2">
									{intl.tr('projects.creation.dialog.company', {
										companyName
									})}
								</Typography>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</DialogContent>
			<DialogActions sx={{ paddingRight: 3, paddingBottom: 3 }}>
				<Button
					onClick={onCancel}
					data-testid="project-create-dialog-cancel-button"
				>
					{intl.tr('button.cancel')}
				</Button>
				<LoadingButton
					variant="contained"
					color="primary"
					disabled={!formik.isValid}
					loading={formik.isSubmitting}
					onClick={() => formik.handleSubmit()}
					data-testid="project-create-approve-button"
				>
					{intl.tr('button.create')}
				</LoadingButton>
			</DialogActions>
		</Dialog>
	);
};

export default ProjectCreateDialog;
